import { setTerm } from './helpers';
import { IJsonQuery } from './types';

export const setBuilderId = setTerm('builder' as unknown as keyof IJsonQuery);
